<template>
  <div class="log-in-screen columns is-centered is-vcentered">
    <div class="column is-one-fourth is-narrow">
      <form action="" @submit.prevent="">
        <b-field custom-class="white" label="Username">
          <b-input type="text" placeholder="Username" rounded></b-input>
        </b-field>
        <b-field custom-class="white" label="Password">
          <b-input type="password" password-reveal placeholder="Password" rounded></b-input>
        </b-field>
        <router-link class="button is-primary is-rounded" :to="{ path: '/' }">Log in</router-link>
      </form>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped lang="scss">
  * {
    transition: all 0.2s ease 0s
  }
  .log-in-screen {
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background:
      linear-gradient(
        unquote('#1e66a7'),
        unquote('#1e66a7')
      );
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
  }

  .column {
    background: transparent;
  }

  form {
    z-index: 2500;
    background-color: #00000099;
    box-shadow: 0px 10px 25px #000;
    border-radius: 20px;
    padding: 2rem;
    margin-top: 0px;
    &:hover {
      margin-top: 15px;
      box-shadow: 0px 5px 15px #000;
    }
  }
  .white {
    color: #fff;
  }
</style>
